import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DenunciasService } from 'src/app/pages/services/denuncias/denuncia.service';
import { Denuncias } from 'src/app/shared/models/denuncia.interface';
import { DenunciaDetailDialogComponent } from '../denuncia-detail-dialog/denuncia-detail-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UpdateModalComponent } from '../update-modal/update-modal.component';

@Component({
  selector: 'app-list-denuncias',
  templateUrl: './list-denuncias.component.html',
  styleUrls: ['./list-denuncias.component.css']
})
export class ListDenunciasComponent implements OnInit {
  displayedColumns: string[] = ['nombre_denunciante', 'nombre_denunciado', 'estado', 'createdAt', 'codigo', 'update', 'actions'];
  dataSource = new MatTableDataSource<Denuncias>();
  statuses = [
    'Denuncia ingresada',
    'En etapa de investigación',
    'Cierre de la investigación',
    'Análisis del proceso investigativo',
    'Remisión de antecedentes a la Dirección del trabajo',
    'En espera de la resolución de la Dirección del trabajo',
    'Cierre del proceso'
  ];
  denuncia_update:any={
    codigo:"",
    estado:"",
  }

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private denunciasService: DenunciasService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.getDenuncias();
  }

  getDenuncias() {
    this.denunciasService.TraerDenuncias().subscribe(
      (res) => {
        this.dataSource.data = res.data.map((item: any) => ({
          ...item,
          createdAt: this.formatDate(item.createdAt)
        }));
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        console.error("Error al obtener denuncias: ", error);
      }
    );
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  

  onStatusChange(newStatus: string, element: Denuncias) {
    this.denuncia_update.estado = newStatus; 
  }

  openDialog(codigo: string): void {
    this.denunciasService.obtenerDenunciaPorCodigo(codigo).subscribe(
      (res) => {
        if (res.success) {
          this.dialog.open(DenunciaDetailDialogComponent, {
            width: '600px',
            data: res.data 
          });
        } else {
          console.error('Error al obtener los detalles de la denuncia');
        }
      },
      (error) => {
        console.error('Error en la solicitud al backend: ', error);
      }
    );
  }

  updateStatus(element: any, newStatus: string): void {
    element.estado = newStatus;
    
    console.log('Actualizando estado para:', element);
    this.denunciasService.updateDenunciaStatus(element).subscribe(
      () => {
        console.log('Estado actualizado exitosamente');
        this.getDenuncias(); // Actualiza los datos de la tabla
      },
      (error) => {
        console.error('Error al actualizar el estado de la denuncia: ', error);
      }
    );
  }
}
